import { MakePaymentFormComponent } from '../../../../forms/dynamic-forms/make-payment-form/make-payment-form.component';
import { MailingAddressSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/mailing-address-svg/mailing-address-svg.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreInfoDivsComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-info-divs/mapfre-info-divs.component';
import { HeaderComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { FormBase } from '@mapfre-design-library/src/public_api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MakePaymentService } from '../../../../../_services/forms/make-payment/make-payment.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Meta } from '@angular/platform-browser';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreInfoDivsComponent, MapfreCardComponent, MailingAddressSvgComponent, MakePaymentFormComponent],
  selector: 'app-make-payment',
  templateUrl: './make-payment.component.html',
  styleUrls: ['./make-payment.component.scss'],
})
export class MakePaymentComponent implements OnInit, OnDestroy {
  inputs: FormBase<any>[];
  isIEBrowser: boolean;
  isAcmic: boolean;

  constructor(
    private makePaymentService: MakePaymentService,
    private acmicService: AcmicService,
    private meta: Meta
  ) {
    this.isAcmic = false;
  }

  ngOnInit() {
    this.meta.addTag({ name: 'robots', content: 'noindex' });
    this.isAcmic = this.acmicService.isACMIC();
    this.inputs = this.makePaymentService.getInputs();
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.isIEBrowser = true;
    }
  }

  ngOnDestroy() {
    this.meta.removeTag('name="robots"');
  }
}
